module.exports = __webpack_public_path__ + "static/img/fundoAzul.ea128a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background/fundoAzul.svg
// module id = AdTD
// module chunks = 1